import { useEffect, useState } from "react";

const TARGET = new Date("2026-08-02T00:00:00Z").getTime();

const computeDays = () => {
  const now = Date.now();
  const diff = TARGET - now;
  if (diff <= 0) return 0;
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const Countdown = ({ className = "" }) => {
  const [days, setDays] = useState(computeDays);

  useEffect(() => {
    // Update once per hour — days only ticks once a day, hourly is plenty.
    const id = setInterval(() => setDays(computeDays()), 60 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="hero-countdown"
      className={`inline-flex items-center gap-2 text-[12px] font-medium tracking-wide text-neutral-500 ${className}`}
    >
      <span
        aria-hidden="true"
        className="pulse-dot inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: "var(--red)" }}
      />
      <span>
        <span className="font-semibold tabular-nums" style={{ color: "var(--ink)" }}>
          {days.toLocaleString()}
        </span>{" "}
        days until enforcement · August 2, 2026
      </span>
    </div>
  );
};

export default Countdown;
